import Box from '@mui/material/Box';
import { Card, Alert, Stack, Typography } from '@mui/material';

import { useTranslate } from 'src/locales';
import { PasswordField, ChannelStepLayout } from 'src/pages/channel/shared';

import { Form, Field } from 'src/components/hook-form';

import { useTelegramStep2 } from '../hooks';

export function TelegramStep2() {
  const { t } = useTranslate('translation');
  const { methods, isNextDisabled, onSubmit } = useTelegramStep2();

  return (
    <Stack spacing={4} sx={{ height: '100%' }}>
      <Form methods={methods} onSubmit={onSubmit}>
        <ChannelStepLayout
          title={t('CONNECT_TELEGRAM')}
          subtitle={t('SETUP_TELEGRAM_CHANNEL_DESCRIPTION')}
          isNextDisabled={isNextDisabled}
        >
          {/* ----------------------------------------------------- */}
          {/*   MAIN CONTENT */}
          {/* ----------------------------------------------------- */}

          <Box sx={{ p: 3, flexGrow: 1, display: 'flex', flexDirection: 'column', gap: 3 }}>
            {/* Channel Name */}
            <Field.Text
              name="channelName"
              label={t('CHANNEL_NAME')}
              placeholder={t('ENTER_CHANNEL_NAME_PLACEHOLDER')}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />

            {/* Bot Token */}
            <PasswordField
              name="botToken"
              label={t('TELEGRAM_BOT_TOKEN')}
              placeholder={t('ENTER_TELEGRAM_BOT_TOKEN')}
            />

            {/* HOW TO CREATE TELEGRAM BOT */}
            <Card sx={{ p: 2, borderRadius: 2 }}>
              <Typography variant="subtitle2" fontWeight={600}>
                {t('HOW_TO_CREATE_TELEGRAM_BOT')}
              </Typography>

              <Typography variant="body2" sx={{ mt: 1 }}>
                {t('TELEGRAM_GUIDE_STEP_1')}
              </Typography>
              <Typography variant="body2">{t('TELEGRAM_GUIDE_STEP_2')}</Typography>
              <Typography variant="body2">{t('TELEGRAM_GUIDE_STEP_3')}</Typography>
              <Typography variant="body2">{t('TELEGRAM_GUIDE_STEP_4')}</Typography>
              <Typography variant="body2">{t('TELEGRAM_GUIDE_STEP_5')}</Typography>

              <Alert severity="info" sx={{ mt: 2 }}>
                {t('TELEGRAM_BOT_ID_INFO')}
              </Alert>
            </Card>
          </Box>
        </ChannelStepLayout>
      </Form>
    </Stack>
  );
}
